import { useState } from 'react';
import { lsGet } from '../lib/storage';
import { useWallet } from '../hooks/use-wallet';
import TopUpSheet from './TopUpSheet';

export default function WalletChip() {
  const userId = lsGet('diwanPrismaUserId');
  const { balance, loading, error, refresh } = useWallet(userId);
  const [showTopUp, setShowTopUp] = useState(false);

  if (!userId) return null;

  const displayBalance = loading
    ? '…'
    : error
      ? '—'
      : `£${((balance ?? 0) / 100).toFixed(2)}`;

  return (
    <>
      <button
        className={`wallet-chip${error ? ' wallet-chip--error' : ''}`}
        onClick={() => error ? refresh() : setShowTopUp(true)}
        aria-label={error ? 'Wallet unavailable. Tap to retry.' : `Wallet balance ${displayBalance}. Tap to top up.`}
        title={error ? 'Tap to retry' : undefined}
      >
        <span className="wallet-chip__label">wallet</span>
        <span className="wallet-chip__balance">{displayBalance}</span>
      </button>

      {showTopUp && (
        <TopUpSheet
          userId={userId}
          currentBalance={balance ?? 0}
          onClose={() => setShowTopUp(false)}
          onSuccess={() => { setShowTopUp(false); refresh(); }}
        />
      )}
    </>
  );
}
